import { createContext, useContext } from "react";

import { AlertContextValue } from "./AlertContextProvider.types";

const defaultValue: AlertContextValue = {
  showError: () => "",
  showErrorWithActivityId: () => "",
  showFormValidationError: () => "",
  showWarning: () => "",
  showInfo: () => "",
  showSuccess: () => "",
  closeAlert: () => {},
};

export const AlertContext = createContext<AlertContextValue>(defaultValue);
export const useAlertContext = (): AlertContextValue => useContext(AlertContext);
